const PROJECTS = [
  {
    id: 1,
    img: require('./img/rs-lang.webp'),
    name: "RS-Lang",
    description: "RS Lang is an application designed to help users learn English. It was developed by a team of randomly selected individuals from a learning course. My responsibilities included setting up and maintaining a Trello board, deploying the project repository, and configuring automatic deployment. I designed and implemented the main page, textbook page, and about us page, as well as implementing the functionality for the sprint game and textbook. Additionally, I served as a team lead and managed the team's workflow and progress throughout the project.",
    deploy: "https://anvianvi.github.io/RS-Lang",
    year: 2022,
    month: 9,
    technologies: ["react", "react-router", "js", "css", "html", "api"]
  },
  {
    id: 2,
    img: require('./img/async-race.webp'),
    name: "Async-race",
    description: "This is an single-page application (SPA) mini-game that provides the ability to perform CRUD operations on cars in a virtual garage. The game also allows running a race with up to 7 cars and saves the history of winners and the car collection, with sorting capabilities. The application uses a 3rd party server API hosted on glitch.com and was written in Vanilla JavaScript.",
    deploy: "https://anvianvi.github.io/async-race-2023/",
    year: 2023,
    month: 1,
    technologies: ["js", "css", "html", "api"]
  },
  {
    id: 3,
    img: require('./img/online-zoo.webp'),
    name: "Online Zoo",
    description: "This is an project that involved developing a multi-page website for an online zoo. It features an adaptive layout and interactive elements on both the main page and the donation page, enhancing the user experience.",
    deploy: "https://anvianvi.github.io/online-zoo/online-zoo/pages/main/",
    year: 2022,
    month: 11,
    technologies: ["js", "css", "html"]
  },

  {
    id: 4,
    img: require('./img/textile-shop.webp'),
    name: "Textile shop",
    description: "A React-based online shop page with search functionality, category sorting, interval filtering, and the ability to view additional product information, as well as add and remove items from the cart.",
    deploy: "https://anvianvi.github.io/custom-shop-react/",
    year: 2022,
    month: 5,
    technologies: ["react", "react-router", "js", "css", "html"]
  },
  {
    id: 5,
    img: require('./img/book-shop.webp'),
    name: "Book Shop",
    description: "Single-page application using vanilla JavaScript that functions as an online bookstore. The application enables users to browse through the catalog of books, view the details of a specific book, add a book to their cart, select a delivery date, and provide a shipping address. The application is optimized for desktop devices with a minimum resolution of 800p.",
    deploy: "https://anvianvi.github.io/book-shop/",
    year: 2022,
    month: 12,
    technologies: ["js", "css", "html",]
  },
  {
    id: 6,
    img: require('./img/shelter.webp'),
    name: "Shelter",
    description: "This is an project that involved developing a multi-page website for a pet shelter. It features an adaptive layout and interactive elements on both the main page and the donation page, enhancing the user experience.",
    deploy: "https://anvianvi.github.io/Shelter/pages/main/",
    year: 2022,
    month: 6,
    technologies: ["js", "css", "html",]
  },
  {
    id: 7,
    img: require('./img/momentum.webp'),
    name: "Momentum",
    description: "Momentum is an analogue of the Chrome Web Store application of the same name. The application displays the time and the user's name. The background image and greeting change depending on the time of day. The application includes a clock, an image slider, weather widgets, a quote of the day block, and settings. Local storage is utilized to store the user's name and location.",
    deploy: "https://anvianvi.github.io/Momentum/",
    year: 2022,
    month: 9,
    technologies: ["js", "css", "html", "api"]
  },

];

export { PROJECTS }